<template>
  <ClientOnly>
    <Teleport to="body">
      <Transition name="modal">
        <div
          v-if="isOpen"
          class="fixed left-0 top-0 size-full flex flex-col items-center justify-center overflow-hidden z-[1000] overscroll-none"
          :class="$attrs.class"
        >
          <div
            class="absolute top-0 left-0 size-full bg-black/85 backdrop-blur-lg"
            @click="closeModal"
          />
          <button
            v-if="!title"
            class="p-1 text-white bg-black-bis/60 hover:bg-black-bis/90 rounded-full size-12 shrink-0 absolute top-4 right-4 z-100 backdrop-blur"
            @click="closeModal"
          >
            <SpriteSymbol name="close" class="size-full" />
          </button>
          <slot name="content">
            <main
              class="modal-container bg-white relative z-10 rounded mx-section-x shadow-xl overflow-hidden"
            >
              <div v-if="title" class="px-4 tablet:px-6">
                <div
                  class="flex justify-between gap-4 tablet:gap-7 border-b border-b-grey-lightest py-4 tablet:py-6 tablet:items-center"
                >
                  <div
                    class="text-black font-bold text-size-5 tablet:text-size-4-5 leading-tight text-balance"
                  >
                    {{ title }}
                  </div>
                  <button
                    class="p-1 hover:bg-white-ter rounded-full size-8 shrink-0"
                    @click="closeModal"
                  >
                    <SpriteSymbol name="close" class="size-full text-black" />
                  </button>
                </div>
              </div>
              <div
                :class="{
                  'p-4 tablet:p-6': title,
                }"
              >
                <div v-if="text" class="text-black text-prose">{{ text }}</div>
                <slot />
              </div>
            </main>
          </slot>
        </div>
      </Transition>
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modalId: string
  card?: boolean
  title?: string
  text?: string
}>()

const { activeModal, closeModal } = useModal()

const isOpen = computed(() => props.modalId === activeModal.value)
</script>

<style lang="postcss">
.modal-enter-active,
.modal-leave-active {
  @apply transition-all duration-300 ease-swing;

  .modal-container {
    @apply transition-all duration-300 ease-bounce;
  }
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;

  .modal-container {
    @apply translate-y-1/2 tablet:translate-y-9 tablet:scale-90;
  }
}

.modal-leave-from,
.modal-enter-to {
  opacity: 1;
}
</style>
